import axiosAPI from "../config/axiosAPI";

export const getUrlImage = async (url, id) => {
  try {
    return await axiosAPI
      .get(`${url}/${id}`, {
        responseType: "blob",
      })
      .then(async (response) => {
        console.log("DataFetchAPI IMAGE response", response);
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = function () {
            console.log("DataFetchAPI IMAGE reader", reader);
            let objPath = {
              filetype: response.data.type,
              base64: reader.result,
            };
            resolve(objPath);
          };
        });
      })
      .catch(async (error) => {
        console.error(`Error: ${error}`);
      });
  } catch (error) {
    console.log("DataFetchAPI IMAGE ERROR", error);
  }
};
